import { Redirect } from 'expo-router'

/** A link that goes nowhere goes home. The tabs decide from there whether the member is signed in. */
const NotFoundScreen = () => <Redirect href="/" />

export default NotFoundScreen
